import { Box, Stack, Typography, IconButton } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesomeRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";

import { useTranslation } from "utils/locales/utilityFunctions";
import { styles } from "../styles";
import { getInternalAppName, getInternalAppType } from "utils/brandingUtils";

type AIChatHeaderProps = {
  onClose: () => void;
};

export function AIChatHeader({ onClose }: AIChatHeaderProps) {
  const { translate } = useTranslation();
  const productName = getInternalAppName(getInternalAppType({ pathOrHost: window.location.hostname }));

  return (
    <Box sx={styles.header}>
      <Box>
        <Stack direction="row" spacing={1}>
          <Typography variant="h5">{translate("ai-chat-header-title", { productName })}</Typography>
          <AutoAwesomeIcon sx={{ opacity: 0.9 }} />
        </Stack>

        <Typography sx={{ color: "primary.lighter" }}>
          {translate("ai-chat-header-subtitle", { productName })}
        </Typography>

        <Typography sx={{ fontSize: 13, opacity: 0.7, color: "white" }}>
          {translate("ai-chat-limitation")}
        </Typography>
      </Box>

      <IconButton onClick={onClose}>
        <CloseIcon sx={{ color: "white" }} fontSize="small" />
      </IconButton>
    </Box>
  );
}
